import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { ChannelName } from '@/interfaces/service/appstore/appstore.interface';
import type { BuisinessAddress, ChannelData, StoreData } from '@/interfaces/service/appstore/appstore.search.interface';

interface SearchState {
  searchResults: ChannelData;
  selectedStores: StoreData;
  prevSelectedStores: StoreData;
  storeName: string;
  setStoreName: (storeName: string) => void;
  setSerachResults: (channelData: ChannelData) => void;
  selectStore: (store: BuisinessAddress | undefined, channelName: ChannelName) => void;
  clearSearchStore: () => void;
}

const undefinedChannelData = {
  KAKAO: undefined,
  NAVER: undefined,
  MODOODOC: undefined,
  GOOGLE: undefined
};

const baseSearchStore = {
  searchResults: { ...undefinedChannelData },
  selectedStores: {
    ...undefinedChannelData
  },
  prevSelectedStores: {
    ...undefinedChannelData
  },
  storeName: ''
};

export const useSearchStore = create<SearchState>((set) => ({
  ...baseSearchStore,
  setStoreName: (storeName) => set((state) => ({ ...state, storeName })),
  setSerachResults: (channelData: ChannelData) =>
    set((state) => ({
      ...state,
      searchResults: channelData
    })),
  selectStore: (store, channelName) =>
    set((state) => ({
      ...state,
      selectedStores: { ...state.selectedStores, [channelName]: store }
    })),
  clearSearchStore: () => set((state) => ({ ...state, ...baseSearchStore }))
}));
